import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ActiveSortService {
  public getActiveSort(clazz: string): string {
    let toReturn = localStorage.getItem(clazz + '-sort');
    return toReturn == null ? null : toReturn;
  }

  public setActiveSort(clazz: string, sort: string): void {
    localStorage.setItem(clazz + '-sort', sort);
  }

  public isActiveSortAscending(clazz: string): boolean {
    let toReturn = localStorage.getItem(clazz + '-sortDir');
    return toReturn == null ? null : toReturn == 'true';
  }

  public setActiveSortAscending(clazz: string, isAscending: boolean): void {
    localStorage.setItem(clazz + '-sortDir', `${isAscending}`);
  }
}
